import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
//import Home from '../pages/home/Home';
import signPage from '../pages/auth/Auth';
import Perfil from '../pages/perfil/Perfil';
import Admin from '../pages/admin/Admin';
import Provider from '../pages/provider/Provider';
import User from '../pages/user/User';
import AccessRestricted from '../pages/accessRestricted/AccessRestricted';
//import Hall from '../components/hall/Hall';
// import Showing from '../components/hall/showing/Showing';

const Routes = () => {
  return (
    <Router>
      <Switch>
        {/* <PrivateRoute path="/hall">
          <Hall/>
        </PrivateRoute> */}
        {/* <PrivateRoute path="/showing">
          <Showing/>
        </PrivateRoute> */}
        <PrivateRoute path="/perfil">
          <Perfil />
        </PrivateRoute>
        <PrivateRoute path="/provider" role="supplier">
          <Provider />
        </PrivateRoute>
        <PrivateRoute path="/admin" role="admin">
          <Admin />
        </PrivateRoute>
        <Route path="/signPage" component={signPage} />
        <Route path="/accessRestricted" component={AccessRestricted} />
        <PrivateRoute path="/" role="pharmacy">
          <User />
        </PrivateRoute>
      </Switch>
    </Router>
  );
};

export default Routes;
